"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("@vue/babel-helper-vue-jsx-merge-props"));
var _utils = require("../utils");
var _functional = require("../utils/functional");
var _icon = _interopRequireDefault(require("../icon"));
// Types

var _use = (0, _utils.use)('nav-bar'),
  sfc = _use[0],
  bem = _use[1];
function NavBar(h, props, slots, ctx) {
  var _bem;
  return h("div", (0, _babelHelperVueJsxMergeProps.default)([{
    "class": [bem((_bem = {
      fixed: props.fixed,
      'use-more-space': props.useMoreSpace
    }, _bem[props.className] = props.className, _bem.popupHeader = props.popupHeader, _bem)), {
      'z-hairline--bottom': props.border
    }],
    "style": {
      zIndex: props.zIndex
    }
  }, (0, _functional.inherit)(ctx)]), [h("div", {
    "class": bem('left'),
    "on": {
      "click": ctx.listeners['click-left'] || _utils.noop
    }
  }, [slots.left ? slots.left() : [props.leftArrow && (!props.popupHeader ? h(_icon.default, {
    "class": bem('arrow'),
    "attrs": {
      "classPrefix": "zziconfont-5",
      "name": "back"
    }
  }) : h(_icon.default, {
    "attrs": {
      "name": 'https://pic5.zhuanstatic.com/zhuanzh/2f485231-4267-4130-9f52-048e89c56e8d.png'
    }
  })), props.leftText && h("span", {
    "class": bem('text')
  }, [props.leftText])]]), h("div", {
    "class": [bem('title', {
      'no-left': !(slots.left || props.leftArrow || props.leftText) && props.useMoreSpace,
      'no-right': !(slots.right || props.rightText) && props.useMoreSpace
    }), 'z-ellipsis']
  }, [slots.title ? slots.title() : props.title]), h("div", {
    "class": bem('right'),
    "on": {
      "click": props.rightDisable ? _utils.noop : ctx.listeners['click-right'] || _utils.noop
    }
  }, [slots.right ? slots.right() : props.rightText && h("span", {
    "class": bem('text', {
      active: props.rightActive,
      disable: props.rightDisable
    })
  }, [props.rightText])])]);
}
NavBar.props = {
  popupHeader: Boolean,
  className: {
    type: String,
    default: ''
  },
  title: String,
  fixed: Boolean,
  leftText: String,
  rightText: String,
  leftArrow: Boolean,
  rightActive: Boolean,
  rightDisable: Boolean,
  useMoreSpace: Boolean,
  border: {
    type: Boolean,
    default: false
  },
  zIndex: {
    type: Number,
    default: 1
  }
};
var _default = sfc(NavBar);
exports.default = _default;